/*@ngInject*/
const SystemPreferencesManagerActionRepository = function (baseRepository, databaseDownloadSectionName, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function () {
        const url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.user.DefaultPreferences:null'
                }
            };

        return this.get(url, config);
    };

    this.backupDefaultPreferences = function () {
        const url = '/database/DatabaseDownloadServlet',
            config = {
                params: {
                    sectionName: databaseDownloadSectionName.DEFAULT_PREFERENCES
                }
            };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    };
};

angular.module('ums.configuration')
    .service('systemPreferencesManagerActionRepository', SystemPreferencesManagerActionRepository);
